import { Component, Inject, OnInit, LOCALE_ID, OnDestroy } from '@angular/core';
import { NbMenuItem, NbIconConfig, NbMenuService } from '@nebular/theme';
import { MENU_ITEMS } from './menu_items';
import { UserMenuService } from '../@apiClient/core/api/api';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { APP_BASE_HREF } from '@angular/common';
import { MenuService } from './menu.service';
import { LocaleService } from '@core/utils';
import { Subscription } from 'rxjs';




@Component({
    selector: 'app-pages',
    template: `
        <app-simple-layout *ngIf="localeLoaded">
            <div menu>
                <nb-menu [items]="menu" tag="menu"></nb-menu>
            </div>
            <router-outlet></router-outlet>
        </app-simple-layout>
    `,
})
export class PageComponent implements OnInit, OnDestroy {
    menu = MENU_ITEMS;
    localeLoaded: boolean = false;
    localeLoadedSubscription: Subscription = null;

    constructor(@Inject(APP_BASE_HREF) private appbasehref: string,
        private localeService: LocaleService,
        private userMenuService: UserMenuService,
        private menuService: MenuService,
        private route: ActivatedRoute,
        private router: Router
    ) {
        this.menuService.reloadEvent.subscribe(() => this.loadMenu());
        
    }

    ngOnInit() {
        this.localeLoaded = this.localeService.islocaleLoaded;
        this.localeLoadedSubscription = this.localeService.localeLoaded.subscribe( x => {
            this.localeLoaded = true;
        });
        if (!this.localeLoaded)
            this.localeService.init();
        this.loadMenu();
    }

    ngOnDestroy() {
        this.localeLoadedSubscription && this.localeLoadedSubscription.unsubscribe();
    }

    loadMenu() {
        const menu = this.menu;
        const appbasehref = this.appbasehref;
        const router = this.router;
        const localUrl = router.url;
        const extended = menu.filter( x => x.expanded ).map( x=> x.link);

        this.userMenuService.getUserMenuItems().subscribe(results => {
            let firstParent: NbMenuItem = null;
            menu.splice(0, menu.length);
            let items = results.data;
            for (const item of items) {

                if (!!item.icon && item.icon.indexOf(":") > 0) {
                    item.icon = { icon: item.icon.split(":")[1], pack: item.icon.split(":")[0] } as unknown as NbIconConfig;
                }
                let badge = null;
                if (!!item.counterName) {
                    badge = {
                        text: item.counterValue,
                        status: 'primary'
                    };
                }
                switch (item.type) {
                    case 0:
                        var lastItem = menu[menu.length - 1];
                        if (!!lastItem && (lastItem as any).type == 0) {
                            // remove empty groups
                            menu.splice(menu.length - 1, 1);
                        }
                        menu.push(<NbMenuItem>{ title: item.name, group: true, type: item.type });
                        break;
                    case 10: // parent without link
                        menu.push(<NbMenuItem>{ title: item.name, group: false, icon: item.icon, data: { type: item.type, counterName: item.counterName }, badge: badge });
                        break;
                    case 1:
                        menu.push(<NbMenuItem>{ title: item.name, group: false, icon: item.icon, link: `/${item.expression}`, selected: `/${item.expression}` === router.url, type: item.type });
                        break;
                    case 2:
                        menu.push(<NbMenuItem>{ title: item.name, group: false, icon: item.icon, selected: `/dashboard/${item.expression}` === router.url, link: `/dashboard/${item.expression}`, type: item.type });
                        break;
                    case 3:
                        menu.push(<NbMenuItem>{ title: item.name, group: false, icon: item.icon, selected: `/documents/list/${item.expression}` === router.url, link: `/documents/list/${item.expression}`, data: { type: item.type, counterName: item.counterName }, badge: badge });
                        break;
                    case 31:
                        if (menu.length > 0) {
                            let parent = menu[menu.length - 1] as NbMenuItem;
                            if (parent.data?.type == 3 || parent.data?.type == 10) {
                                let link = `/documents/list/${item.expression}`;
                                if (!firstParent) firstParent = parent;
                                if (parent.children == null) parent.children = [];
                                let selected = `/documents/list/${item.expression}` === router.url;
                                if (selected) {
                                    parent.expanded = true;
                                    parent.selected = true;
                                }
                                if (extended.includes(parent.link)){
                                    parent.expanded = true;
                                }
                                parent.children.push(<NbMenuItem>{ parent: parent, pathMatch: "full", title: item.name, group: false, icon: item.icon, link: link, selected: selected, data: { type: item.type, counterName: item.counterName }, badge: badge });
                            }
                        }
                        break;
                    case 35:
                        if (menu.length > 0) {
                            let parent = menu[menu.length - 1] as NbMenuItem;
                            if (parent.data?.type == 3 || parent.data?.type == 10) {
                                let link = `/documents/calendar/${item.expression}`;
                                if (!firstParent) firstParent = parent;
                                if (parent.children == null) parent.children = [];
                                let selected = `/documents/calendar/${item.expression}` === router.url;
                                if (selected) {
                                    parent.expanded = true;
                                    parent.selected = true;
                                }
                                if (extended.includes(parent.link)){
                                    parent.expanded = true;
                                }
                                parent.children.push(<NbMenuItem>{ parent: parent, pathMatch: "full", title: item.name, group: false, icon: item.icon, link: link, selected: selected, data: { type: item.type } });
                            }
                        }
                        break;
                    case 4:
                        menu.push(<NbMenuItem>{ title: item.name, group: false, icon: item.icon, selected: `/documents/tree/${item.expression}` === router.url, link: `/documents/tree/${item.expression}`, type: item.type });
                        break;
                    case 41:
                        if (menu.length > 0) {
                            let parent = menu[menu.length - 1] as NbMenuItem;
                            if (parent.data.type == 3 || parent.data.type == 10) {
                                let link = `/documents/tree/${item.expression}`;
                                if (!firstParent) firstParent = parent;
                                if (parent.children == null) parent.children = [];
                                let selected = `/documents/tree/${item.expression}` === router.url;
                                if (selected) {
                                    parent.expanded = true;
                                    parent.selected = true;
                                }
                                if (extended.includes(parent.link)){
                                    parent.expanded = true;
                                }
                                parent.children.push(<NbMenuItem>{ parent: parent, pathMatch: "full", title: item.name, group: false, icon: item.icon, selected: selected, link: link, type: item.type });
                            }
                        }
                        break;
                    case 5:
                        menu.push(<NbMenuItem>{ title: item.name, group: false, icon: item.icon, selected: `/documents/calendar/${item.expression}` === router.url, link: `/documents/calendar/${item.expression}`, type: item.type });
                        break;
                }
            }
            this.router.events.subscribe(
                event => {
                    if (event instanceof NavigationEnd && !menu.some(value => value.link === event.url ||
                        (value.children && value.children.some(child => child.link === event.url)))) {
                        menu.forEach(element => {
                            element.selected = false;
                            if (element.children) {
                                element.children.forEach(child => child.selected = false);
                            }
                        })
                    }
                }
            )
            if (firstParent) {
                if (firstParent.children.some(child => child.selected)) {
                    firstParent.selected = true;
                } else {
                    firstParent.selected = false;
                }
                firstParent.expanded = true;
            }

            if (router.url === appbasehref || localUrl === appbasehref) {
                // navigate to first active menu action
                var firstItem = menu.find(m => m.group == false);
                if (!firstItem.link || firstItem.children?.length > 0) { firstItem = firstItem.children[0]; }
                router.navigate([firstItem.link]);
            }
        });
    }
}
